import React from "react";
import { Link } from "react-router-dom";
import styles from "./Cta.module.css";

const Cta = () => {
  return (
    <div className={styles.cta}>
      <div className={styles.ctaContainer}>
        <div className={styles.ctaContent}>
          <div>
            <p className={styles.ctaText}>
              Ready to transform your real estate career?
            </p>
            <p className={styles.ctaSubText}>
              Join FirstLand today and let’s revolutionize the way you do
              business <span style={{ fontWeight: "900" }}>together!</span>
            </p>
          </div>

          <div className="pt-6 lg:mx-12">
            <Link to="/contact" className={styles.ctaButton}>
              Get Started Now
              <svg
                className={styles.ctaButtonIcon}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cta;
